import { generativeModel } from "./firebase";

/**
 * Summarizes content using the Vertex AI Gemini model
 * @param {string} content - The text content to be summarized
 * @returns {Promise<string>} A promise that resolves to the summarized text
 * @throws {Error} If the content generation fails
 */
export const summarizeContent = async (content) => {
  const result = await generativeModel.generateContent(content);
  const { response } = result;
  return response.text();
};
